import Model from './Model'

export default class ObjectionModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'objections'
  }
}
